import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { taskList } from '@blade/common/api/photo';
import '@blade/common/assets/styles/photo.scss';
import { AlarmWebsocket as PhotoWebsocket } from '@blade/common/utils/websocket';
import { EPhotoStatus } from '@blade/common/interfaces/upload';
import EventBus, { EventKeys } from '@blade/common/utils/eventbus';
import { FileUploadModule } from '@blade/common/store/file-upload';
import { userMapping } from '@blade/common/constants/user-mode';
// const groupMapping = {
//   USER: 'white',
//   GUEST: 'visitor',
//   BLACKLIST: 'black',
// };
let default_1 = class default_1 extends Vue {
    value = '';
    list = [];
    fileName = '';
    sort = 'DESC';
    upWS;
    upWSurl = this.mapUrl();
    cs = [
        {
            creatorName: 'luoshi',
            fileName: 'minio.zip',
            taskId: '7fa29f59149d4f12a6045319c0e23222',
            updateTime: '2020-10-16T08:24:05.000+00:00',
            state: {
                picNum: 0,
                processedNum: 0,
                processingProgress: 0,
                state: 'PROCESSING',
                validNum: 0,
            },
        },
        {
            creatorName: 'luoshi',
            fileName: 'minio.zip',
            taskId: '30b40dde80884f7cafa025a9de0eea6c',
            updateTime: '2020-10-16T08:24:05.000+00:00',
            state: {
                picNum: 0,
                processedNum: 0,
                processingProgress: 0,
                state: 'PROCESS_COMPLETED',
                validNum: 0,
            },
        },
    ];
    selectOpts = [];
    outerPage = 1;
    outerPageSize = 10;
    totalNum = 0;
    currPage = 1;
    listLoading = false;
    state = '';
    filtered;
    creatorName = '';
    updateToComplete = false;
    group = 'USER';
    // get name() {
    //   return UserModule.name
    // }
    // get roles() {
    //   return UserModule.roles
    // }
    get disabled() {
        console.log('disable:', FileUploadModule.uploading);
        return FileUploadModule.uploading;
    }
    get uploadPercent() {
        console.log('per:', FileUploadModule.uploadPer);
        return FileUploadModule.uploadPer;
    }
    onLocaleChange() {
        this.getTaskList();
    }
    mapUrl() {
        const res = process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_UPLOAD_WS
            : `wss://${window.location.host}/${process.env.VUE_APP_UPLOAD_WS}`;
        return res || '';
    }
    getPercent(num) {
        console.log('num:', num);
        if (num < 0 || num > 100) {
            return 0;
        }
        return num;
    }
    get filterData() {
        return [
            {
                text: this.$t('uploadSuccessfully'),
                value: EPhotoStatus.PROCESS_COMPLETED,
            },
            {
                text: this.$t(EPhotoStatus.UPLOAD_INTERRUPTED),
                value: EPhotoStatus.UPLOAD_INTERRUPTED,
            },
            {
                text: this.$t(EPhotoStatus.PROCESS_INTERRUPTED),
                value: EPhotoStatus.PROCESS_INTERRUPTED,
            },
            { text: this.$t('uploading'), value: EPhotoStatus.UPLOADING },
            { text: this.$t('processFail'), value: 'PROCESS_FAILED' }
        ];
    }
    handlePause(state, id) {
        console.log('pause');
        if (FileUploadModule.uploading || state === EPhotoStatus.UPLOADING) {
            FileUploadModule.updateTask({
                id: id,
                state: EPhotoStatus.UPLOAD_INTERRUPTED,
            });
            EventBus.$emit(EventKeys.UploadPause);
        }
        else {
            FileUploadModule.updateTask({
                id: id,
                state: EPhotoStatus.PROCESS_INTERRUPTED,
            });
        }
        this.getTaskList();
    }
    showProgress(state) {
        return state === EPhotoStatus.UPLOADING || state === EPhotoStatus.PROCESSING;
    }
    mounted() {
        const { meta } = this.$route;
        this.group = meta.group;
        console.log('group:', meta.group);
        this.getTaskList(true);
        this.initWebsocket();
        EventBus.$on(EventKeys.FileInitialized, this.handleFilUpload);
        this.getNames();
    }
    async getNames() {
        try {
            const res = await FileUploadModule.getUserNames({ libraryType: 0, userMode: userMapping[this.group] });
            console.log('name:', res);
            const removeDup = Array.from(new Set(res));
            this.selectOpts = removeDup.map((item) => ({
                text: item,
                value: item,
            }));
            console.log('select opts:', this.selectOpts);
        }
        catch (e) { }
    }
    handleFilUpload() {
        console.log('file initialized');
        this.outerPage = 1;
        this.getTaskList();
    }
    initWebsocket() {
        this.upWS = new PhotoWebsocket(this.upWSurl);
        this.upWS.setOnMessage(this.websocketonmessage);
    }
    websocketonmessage(e) {
        // console.log(e.data);
        let socList = [];
        socList.push(JSON.parse(e.data));
        console.log(socList);
        socList = socList.map((item) => {
            const status = this.mapState(item.state.state);
            return {
                ...item,
                stauts: status,
            };
        });
        socList.forEach((item) => {
            const num = this.list.findIndex((son) => {
                return item.taskId === son.taskId;
            });
            // console.log(num);
            this.$set(this.list, num, item);
            console.log(this.list);
        });
    }
    destroyed() {
        this.upWS && this.upWS.close(); // 离开路由之后断开websocket连接
        FileUploadModule.reset();
    }
    csFunc() {
        setTimeout(() => {
            let socList = this.cs;
            socList = socList.map((item) => {
                const stauts = this.mapState(item.state.state);
                return {
                    ...item,
                    stauts: stauts,
                };
            });
            console.log(socList);
            socList.forEach((item) => {
                let num = this.list.findIndex((son) => {
                    return item.taskId === son.taskId;
                });
                this.$set(this.list, num, item);
                console.log(socList);
            });
        }, 5000);
    }
    async getTaskList(initial) {
        console.log('initial:', initial);
        const tasksFilter = {
            fileName: this.fileName,
            sort: this.sort,
            page: this.outerPage,
            size: this.outerPageSize,
            creatorName: this.creatorName,
            userMode: userMapping[this.group],
            libraryType: 0,
        };
        const data = this.state ? { ...tasksFilter, state: this.state } : { ...tasksFilter };
        this.listLoading = true;
        try {
            const res = await taskList(data);
            // console.log(res);
            this.totalNum = res.data.data.total;
            const taskVos = res.data.data.list;
            const list = [];
            for (let i = 0; i < taskVos.length; i++) {
                const item = taskVos[i];
                let oriStatus = item.state.state;
                if (initial) {
                    if (oriStatus === EPhotoStatus.UPLOADING) {
                        oriStatus = EPhotoStatus.UPLOAD_INTERRUPTED;
                        await this.updateUploading(item.taskId);
                    }
                }
                const status = this.mapState(oriStatus);
                const { state, ...rest } = item;
                state.state = oriStatus;
                const res = { ...rest, stauts: status, state };
                list.push(res);
            }
            this.list = list;
            console.log(this.list);
        }
        catch (e) {
        }
        finally {
            this.listLoading = false;
        }
    }
    async updateUploading(id) {
        try {
            await FileUploadModule.updateTask({ state: EPhotoStatus.UPLOAD_INTERRUPTED, id: id });
        }
        catch (e) { }
    }
    handleEdit(id) {
        this.$router.push(`${this.$route.path}/task/${id}`);
    }
    searchFile() {
        this.getTaskList();
    }
    handlePagination(value) {
        this.outerPage = value;
        this.getTaskList();
    }
    async filterHandler(value, row, column) {
        let property = column['property'];
        console.log('property:', row[property]);
        // this.state=value;
        // await this.getTaskList();
        // return this.list;
        // return row[property]
        // return row[property] === value;
    }
    handleSizeNavigation(value) {
        this.outerPageSize = value;
        this.getTaskList();
    }
    handleReUpload(id) {
        console.log(id);
        EventBus.$emit(EventKeys.ReUpload, id);
    }
    mapState(status) {
        switch (status) {
            case EPhotoStatus.UPLOAD_INTERRUPTED:
                return this.$t('error');
            case EPhotoStatus.PROCESS_COMPLETED:
                return this.$t('success');
            case EPhotoStatus.UPLOADING:
            case EPhotoStatus.UPLOAD_COMPLETED:
            case EPhotoStatus.PROCESS_WAITING:
            case EPhotoStatus.PROCESSING:
                return this.$t('uploading');
        }
    }
    onStateChange(newVal) {
        this.outerPage = 1;
        this.getTaskList();
    }
    onuploadPercentChange(newVal) {
        console.log('uploadPercent:', newVal);
    }
    handleFilter(val) {
        console.log('val:', val);
        if (val['status']) {
            const currFilter = val['status'][0];
            this.state = currFilter;
        }
        if (val['name']) {
            const currUser = val['name'][0];
            this.creatorName = currUser;
        }
        this.outerPage = 1;
        this.getTaskList();
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
__decorate([
    Watch('state')
], default_1.prototype, "onStateChange", null);
__decorate([
    Watch('uploadPercent')
], default_1.prototype, "onuploadPercentChange", null);
default_1 = __decorate([
    Component({
        name: 'PhotoList',
        filters: {},
        i18n: {
            messages: {
                'en-us': {
                    search: 'Search',
                    id: 'Id',
                    label: 'label',
                    name: 'Portrait name',
                    creator: 'Created By',
                    updateTime: 'Updated Time',
                    percent: 'Valid/All',
                    status: 'Status',
                    actions: 'Operation',
                    detail: 'Details',
                    reUpload: 're-upload',
                    packageName: 'Portrait package name',
                    error: 'error',
                    success: 'success',
                    uploading: 'uploading',
                    uploadAborted: 'Upload aborted',
                    processingAborted: 'Processing aborted',
                    uploadSuccessfully: 'Completed successfully',
                    UPLOAD_INTERRUPTED: 'Upload interrupted',
                    PROCESS_INTERRUPTED: 'Process interrupted',
                    processFail: 'Process Failed',
                    uploadCompleted: 'Upload successfully',
                    remark: 'Fail Reason'
                },
                zh: {
                    search: '搜索',
                    id: 'Id',
                    label: '命名',
                    name: '人像包名称',
                    creator: '创建人',
                    updateTime: '更新时间',
                    percent: '有效人像/总人像',
                    status: '状态',
                    actions: '操作',
                    detail: '详情',
                    reUpload: '重新上传',
                    packageName: '人像包名称',
                    error: '失败',
                    success: '成功',
                    uploading: '上传中',
                    uploadAborted: '上传中止',
                    processingAborted: '处理中止',
                    uploadSuccessfully: '上传入库成功',
                    UPLOAD_INTERRUPTED: '上传错误',
                    PROCESS_INTERRUPTED: '入库中断',
                    processFail: '入库错误',
                    uploadCompleted: '上传成功',
                    remark: '失败原因'
                },
            },
        },
    })
], default_1);
export default default_1;
